import React, { useState, useEffect, useCallback } from "react";
import CargandoSpinner from "../../0. Utilidades/loadingSpinner";

const DocumentsSection = ({ maestraRut }) => {
  const [newDocument, setNewDocument] = useState(null);
  const [documents, setDocuments] = useState([]); // State to store fetched documents
  const [documentName, setDocumentName] = useState(""); // State for document name
  const [isLoading, setIsLoading] = useState(true); // State to handle loading

  // Function to fetch CSRF token from the backend
  const fetchCSRFToken = async () => {
    const apiUrlcsrf = `${process.env.REACT_APP_BASE_API}api/csrf_token/`;
    const response = await fetch(apiUrlcsrf, { credentials: "include" });
    const data = await response.json();
    return data.csrfToken;
  };

  // Function to fetch documents associated with the maestra
  const fetchDocuments = useCallback(async () => {
    setIsLoading(true);
    const apiUrl = `${process.env.REACT_APP_BASE_API}api/perfiles/maestras/${maestraRut}/documentos/`;
    try {
      const response = await fetch(apiUrl);
      const data = await response.json();
      setDocuments(data); // Ensure data is an array
    } catch (error) {
      console.error("Error fetching documents:", error);
      setDocuments([]); // Set to empty array in case of error
    } finally {
      setIsLoading(false);
    }
  }, [maestraRut]);

  // Fetch documents when component mounts and when maestraRut changes
  useEffect(() => {
    fetchDocuments();
  }, [fetchDocuments]);

  // Function to handle document name input
  const handleDocumentNameChange = (e) => {
    setDocumentName(e.target.value);
  };

  // Function to handle new document submission
  const handleDocumentSubmit = async () => {
    if (!newDocument || !documentName) {
      alert("Please select a file and provide a name.");
      return;
    }

    const csrfToken = await fetchCSRFToken();
    const formData = new FormData();
    formData.append("documento", newDocument);
    formData.append("maestra", maestraRut);
    formData.append("nombre", documentName);

    const apiUrl = `${process.env.REACT_APP_BASE_API}api/perfiles/documentos/`;

    fetch(apiUrl, {
      method: "POST",
      headers: { "X-CSRFToken": csrfToken },
      body: formData,
      credentials: "include",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        console.log("Success:", data);
        setNewDocument(null);
        setDocumentName(""); // Clear the document name input
        fetchDocuments(); // Refetch documents to update the list with the new document
      })
      .catch((error) => console.error("Error:", error));
  };

  return (
    <div className="maestra-info">
      <h5>Subir Documento</h5>
      <input
        type="text"
        placeholder="Colocar nombre al documento..."
        value={documentName}
        onChange={handleDocumentNameChange}
      />
      <input
        type="file"
        accept=".pdf"
        onChange={(e) => setNewDocument(e.target.files[0])}
      />
      <button onClick={handleDocumentSubmit} className="btn btn-primary">
        Subir PDF
      </button>

      <h5>Documentos Subidos</h5>
      {isLoading ? (
        <CargandoSpinner />
      ) : documents && documents.length > 0 ? (
        <ul>
          {documents.map((doc) => (
            <li key={doc.id}>
              <a href={doc.documento} target="_blank" rel="noopener noreferrer">
                {doc.nombre}
              </a>
              <span> {doc.date_observed}</span>
            </li>
          ))}
        </ul>
      ) : (
        <p>No hay documentos subidos.</p>
      )}
    </div>
  );
};

export default DocumentsSection;
